/**
 * Viewport width below which quotes uses the mobile card compose flow.
 */
export const QUOTES_MOBILE_LAYOUT_MAX_WIDTH_PX = 768;

/**
 * Returns true when the quotes feature should use mobile layout (card list, mobile compose).
 * Uses viewport width so touch-enabled desktops still get the AG Grid compose flow.
 */
export function isQuotesMobileLayout(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.innerWidth < QUOTES_MOBILE_LAYOUT_MAX_WIDTH_PX;
}
